import { render, staticRenderFns } from "./Sports.vue?vue&type=template&id=179402ab&scoped=true&"
import script from "./Sports.vue?vue&type=script&lang=js&"
export * from "./Sports.vue?vue&type=script&lang=js&"
import style0 from "./Sports.vue?vue&type=style&index=0&id=179402ab&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179402ab",
  null
  
)

export default component.exports